import { render, staticRenderFns } from "./pre_happy.vue?vue&type=template&id=f8684d84&scoped=true"
import script from "./pre_happy.vue?vue&type=script&lang=js"
export * from "./pre_happy.vue?vue&type=script&lang=js"
import style0 from "./pre_happy.vue?vue&type=style&index=0&id=f8684d84&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8684d84",
  null
  
)

export default component.exports